import * as React from "react";
import { NumberInput as NumberInputAtom } from "../../atoms/forms/NumberInput";
import { ICommonControlWithMinMax } from "./ICommonInputsControls";

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonControlWithMinMax<number>;
export const NumberInput = (props: AllProps) => {
    return (
        <NumberInputAtom
            label={props.label || ""}
            value={props.value}
            loading={props.loading}
            disabled={props.disabled}
            required={props.required}
            error={props.error}
            placeholder={props.placeholder}
            prevalidate={props.prevalidate}
            icon={props.icon}
            minValue={props.minValue}
            maxValue={props.maxValue}
            onChange={props.onChange}
            onValidate={props.onValidate}
        />
    );
};

